export default __webpack_public_path__ + "static/media/e08f45dd3972359b.e4a6b8fd285b4895e7a6f66a7f37c2f2.svg";